import hypercube from '../../api/hypercube';
import { FETCH_VENDORS } from '../types';

export const fetchVendors = () => async (dispatch) => {
  const res = await hypercube.get('/vendors?sortBy=createdAt:asc&limit=10');

  dispatch({ type: FETCH_VENDORS, payload: res.data });
};
